// extracted by mini-css-extract-plugin
module.exports = {"imageWithAttribution":"imageWithAttribution_imageWithAttribution__oJNEG"};